import { observable, action } from 'mobx'
import Api from '@api/rhinocerosAcademy'
import { RHINOCEROS_ACADEMY_A } from '@constant'

class Store {
  @observable data = {}
  @action
  getData = async () => {
    const { data, success } = await Api.rhinoCollege()
    if (success) {
      this.data = data || {}
    }
  }

  @action
  gotoPage = (id, title) => () => {
    window.location.href = `${RHINOCEROS_ACADEMY_A}?id=${id}&title=${title}`
  }
}
export default Store
